/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.social-icons-and-register-row[_ngcontent-%COMP%]{display:flex}.social-icons-hidden[_ngcontent-%COMP%]   .register-button[_ngcontent-%COMP%]{width:100%}.social-buttons[_ngcontent-%COMP%]{flex:1 1 auto}.register-button-container[_ngcontent-%COMP%]{flex:1 1 auto;text-align:right}.info-row[_ngcontent-%COMP%]{margin:35px 0 5px;text-align:center}.big-social-auth-button[_ngcontent-%COMP%]{margin-top:25px}.login-link[_ngcontent-%COMP%]{padding-left:5px}"];
export { styles as styles };
